const answers: Mapping[] = [
  {
    label: '-',
    value: 0,
  },
  {
    label: '無事',
    value: 1,
  },
  {
    label: '軽傷',
    value: 2,
  },
  {
    label: '重傷',
    value: 3,
  },
];

export default answers;
